import moment from 'moment';

const ONE_DAY = 86400; // ruby 1.days.to_i
const THREE_DAYS = 259200; // ruby 3.days.to_i
const ONE_MONTH = 2629746; // ruby 1.month.to_i

export default function(intl) {
  return (slice, filter) => {
    const { formatDate } = intl;
    const { startDate, endDate } = filter;

    const seconds = moment(new Date(endDate))
      .endOf('day')
      .diff(moment(new Date(startDate)).startOf('day'), 'seconds');
    if (seconds <= ONE_DAY) {
      // hours
      return formatDate(new Date(slice.timestamp), {
        hour: 'numeric',
        minute: 'numeric'
      });
    } else if (seconds <= THREE_DAYS) {
      // hours and days
      return formatDate(new Date(slice.timestamp), {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
    } else if (seconds <= ONE_MONTH) {
      // day
      return formatDate(new Date(slice.timestamp), {
        month: 'short',
        day: 'numeric'
      });
    } else {
      // month and year
      return formatDate(new Date(slice.timestamp), {
        year: 'numeric',
        month: 'short'
      });
    }
  };
}
